import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Redirects the user to the appropriate landing page based on their role.
 *
 * - admin → /admin (Special Regulations management)
 * - event → /events (Race event management)
 * - user  → /dashboard (Race events dashboard)
 */
const RoleRedirect: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) return <p>Loading…</p>;

  switch (user?.role) {
    case 'admin':
      return <Navigate to="/admin" replace />;
    case 'event':
      return <Navigate to="/events" replace />;
    default:
      return <Navigate to="/dashboard" replace />;
  }
};

export default RoleRedirect;
